import {accountingAddOn, giftcardAddOn, webshopAddOn} from '../utils/addons'

const bgColor = 'rgb(223, 242, 243)'

const promotionPages = [

  // 1. WEBSHOP
  {
    addOnEnumTypeId: webshopAddOn,
    name: 'webshop',

    modules: []
  },
  // 2. GIFTCARD
  {
    addOnEnumTypeId: giftcardAddOn,
    name: 'giftcard',
    modules: []
  },
  // 3. Accounting
  {
    addOnEnumTypeId: accountingAddOn,
    name: 'accounting',
    modules: []
  },
  // Home pages
  {
    addOnEnumTypeId: null,
    name: 'homepage',
    modules: []
  }
]

export default promotionPages
